import React, { useEffect, useRef, useState } from 'react';
import { useSharedCart } from '../../entrypoints/theme';
import styles from './MiniCart.module.scss';
import Bag from '../Icons/Bag';
import Savings from '../SavingValue/SavingValue';
import CheckoutButton from '../CheckoutButton/CheckoutButton';
import ShippingBar from '../ShippingBar/ShippingBar';
import CartContent from '../CartContent/CartContent';
import Recommendations from '../Recommendations/Recommendations';
import MiniGifts from '../MiniGifts/MiniGifts';
import GiftPopup from '../GiftPopup/GiftPopup';

const MiniCart = () => {
  const { cartState, closeMiniCart, openGiftPopup } = useSharedCart();
  const isEmpty = !cartState.items || cartState.items.length === 0;
  const miniCartRef = useRef(null);
  const [isScrollableContentVisible, setIsScrollableContentVisible] = useState(
    typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches
  );
  const isCartPage = window.location.pathname.startsWith('/cart');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartState.isMiniCartOpen && miniCartRef.current && !miniCartRef.current.contains(event.target)) {
        closeMiniCart();
      }
    };

    if (cartState.isMiniCartOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [cartState.isMiniCartOpen, closeMiniCart]);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/products/')) {
      const pathParts = path.split('/');
      if (pathParts.length > 2 && pathParts[2]) {
        const productHandle = pathParts[2];
        const MAX_RECENT_ITEMS = 20;
        const STORAGE_KEY = 'recentlyViewedProductHandles';

        try {
          let viewedHandles = [];
          const storedHandles = localStorage.getItem(STORAGE_KEY);
          if (storedHandles) {
            const parsedHandles = JSON.parse(storedHandles);
            // Ensure it's an array before proceeding
            if (Array.isArray(parsedHandles)) {
              viewedHandles = parsedHandles;
            }
          }
          // Remove the handle if it already exists to move it to the front
          viewedHandles = viewedHandles.filter(h => h !== productHandle);
          viewedHandles.unshift(productHandle);
          const updatedViewedHandles = viewedHandles.slice(0, MAX_RECENT_ITEMS);

          localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedViewedHandles));
        } catch (error) {
          console.error("Error updating recently viewed products in localStorage:", error);
        }
      }
    }
  }, []); // Empty dependency array ensures this runs once when the component mounts

  const toggleScrollableContent = () => {
    setIsScrollableContentVisible(!isScrollableContentVisible);
  };

  return (
    <>
      <div ref={miniCartRef} className={`${styles.miniCart} ${cartState.isMiniCartOpen ? styles.open : ''}`}>
        <div className={styles.header}>
          <span className={styles.title}> 
            <span className={styles.bagIcon}><Bag /></span>
            My Cart</span>
          <button className={styles.closeButton} onClick={closeMiniCart} aria-label="Close cart">
            &times;
          </button>
        </div>
        <ShippingBar />
        <div className={`${styles.content}`}>
          <CartContent />
        </div>
        <div className={styles.footer}>
          {!isEmpty && (
            <>
              <div className={styles.subtotal}>
                <span className={styles.label}>You Saved:&nbsp;</span>
                <span className={styles.amount}><Savings /></span>
              </div>
              <CheckoutButton />
            </>
          )}
          <button
            className={styles.toggleButton}
            onClick={toggleScrollableContent}
            aria-expanded={isScrollableContentVisible}
            aria-controls="mini-cart-scrollable-content"
          style={{ marginBottom: isScrollableContentVisible ? '0' : '1rem' }}
          >
            {isScrollableContentVisible ? '▼' : '▲'}
          </button>
          <div id="mini-cart-scrollable-content" className={styles.scrollableContent} style={{ maxHeight: isScrollableContentVisible ? '520px' : '140px' }}>
            <MiniGifts inMiniCart={true} />
            <div className={styles.recommendations}>
              <Recommendations />
            </div>
          </div>
        </div>
      </div>
      {cartState.isGiftPopupOpen && <GiftPopup />}
    </>
  );
};

export default MiniCart;
